import chipax from './Int_CHIPAX.svg'
import clayApiToken from './Int_CLAY.svg'
import payflow from './Int_PAYFLOW.svg'
import previred from './Int_PREVIRED.svg'
import sii from './Int_SII.svg'
import tgr from './Int_TGR.svg'
import transbank from './Int_TRANSBANK.svg'
import talana from './Int_TALANA.svg'
import buk from './Int_BUK.svg'
import cobranzaOnline from './Int_COBRANZA.svg'
import bsaleApiToken from 'src/assets/svg/platforms/bsale.png'
import rindegastos from 'src/assets/svg/platforms/rindegastos.png'
import fincloud from 'src/assets/svg/platforms/fincloud.png'

const platforms = {
    chipax,
    clayApiToken,
    payflow,
    previred,
    sii,
    tgr,
    transbank,
    talana,
    buk,
    bsaleApiToken,
    cobranzaOnline,
    rindegastos,
    fincloud,
}

const platformLogo = (platform) => {
    if (platforms[platform]) return platforms[platform]
    if (platform == 'siiApoderado') return platforms.sii
    return ''
}

export default platformLogo